export default __webpack_public_path__ + "static/media/waves-wrap-roll.87ab3feb.png";